import React from 'react';
import { getUserInfo } from './auth';

export const AuthContext = React.createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = React.useState(undefined); // undefined = 초기 로딩 중
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    getUserInfo()
      .then(u => setUser(u))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const isSuwannews =
    !!user &&
    (user.login === 'suwannews' ||
      user.user_login === 'suwannews' ||
      user.preferred_username === 'suwannews' ||
      user.nickname === 'suwannews');

  return (
    <AuthContext.Provider value={{ user, setUser, isSuwannews, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
